import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './firewall-configuration-review.css'

const FirewallConfigurationReview = (props) => {
  return (
    <div className="firewall-configuration-review-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Firewall-Configuration-Review - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/firewall-configuration-review"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section firewall-configuration-review-hero-section">
        <div className="hero-media">
          <img
            alt="Focused detail of a modern server rack with blue LED indicators in a data center."
            src="https://images.pexels.com/photos/17489156/pexels-photo-17489156.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-background-image firewall-configuration-review-hero-background-image"
          />
        </div>
        <div className="firewall-configuration-review-hero-overlay hero-overlay"></div>
        <div className="firewall-configuration-review-hero-content-wrapper">
          <div className="hero-content firewall-configuration-review-hero-content">
            <div className="hero-icon-badge">
              <svg
                width="32"
                xmlns="http://www.w3.org/2000/svg"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h1 className="hero-title firewall-configuration-review-hero-title">
              Firewall Configuration Review &amp; Hardening
            </h1>
            <p className="firewall-configuration-review-hero-subtitle hero-subtitle">
              Comprehensive security assessment and optimization of your
              firewall infrastructure to eliminate vulnerabilities, improve
              network segmentation, and ensure compliance with industry
              standards.
            </p>
            <div className="firewall-configuration-review-hero-actions">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#methodology">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Methodology</span>
                </div>
              </a>
            </div>
            <div className="firewall-configuration-review-hero-stats">
              <div className="firewall-configuration-review-hero-stat-item">
                <span className="firewall-configuration-review-hero-stat-value">
                  99.7%
                </span>
                <span className="firewall-configuration-review-hero-stat-label">
                  Risk Reduction
                </span>
              </div>
              <div className="firewall-configuration-review-hero-stat-item">
                <span className="firewall-configuration-review-hero-stat-value">
                  72hrs
                </span>
                <span className="firewall-configuration-review-hero-stat-label">
                  Initial Report
                </span>
              </div>
              <div className="firewall-configuration-review-hero-stat-item">
                <span className="firewall-configuration-review-hero-stat-value">
                  100%
                </span>
                <span className="firewall-configuration-review-hero-stat-label">
                  Compliance Ready
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="firewall-configuration-review-services-section">
        <div className="services-container firewall-configuration-review-services-container">
          <div className="firewall-configuration-review-services-header services-header">
            <h2 className="section-title">
              Comprehensive Firewall Review Services
            </h2>
            <p className="section-subtitle">
              Strategic analysis and hardening to protect your network perimeter
            </p>
          </div>
          <div className="firewall-configuration-review-services-grid">
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Rule Discovery &amp; Inventory
              </h3>
              <p className="firewall-configuration-review-service-description">
                Complete documentation of existing firewall rules, policies, and
                configurations across all network segments and zones.
              </p>
            </div>
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Policy Risk Assessment
              </h3>
              <p className="firewall-configuration-review-service-description">
                Identify overly permissive rules, outdated policies, shadow
                rules, and security gaps that expose your network to threats.
              </p>
            </div>
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                    <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                    <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                  </g>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Network Segmentation Analysis
              </h3>
              <p className="firewall-configuration-review-service-description">
                Evaluate network segmentation effectiveness, zone isolation, and
                traffic flow patterns to minimize lateral movement risks.
              </p>
            </div>
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Rule Optimization &amp; Cleanup
              </h3>
              <p className="firewall-configuration-review-service-description">
                Consolidate redundant rules, remove obsolete entries, and
                streamline policy sets for improved performance and security.
              </p>
            </div>
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Compliance Mapping
              </h3>
              <p className="firewall-configuration-review-service-description">
                Align firewall configurations with ISO 27001, SOC 2, PCI-DSS,
                and other regulatory frameworks to ensure audit readiness.
              </p>
            </div>
            <div className="firewall-configuration-review-service-card">
              <div className="firewall-configuration-review-service-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0a2.34 2.34 0 0 0 3.319 1.915a2.34 2.34 0 0 1 2.33 4.033a2.34 2.34 0 0 0 0 3.831a2.34 2.34 0 0 1-2.33 4.033a2.34 2.34 0 0 0-3.319 1.915a2.34 2.34 0 0 1-4.659 0a2.34 2.34 0 0 0-3.32-1.915a2.34 2.34 0 0 1-2.33-4.033a2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <circle r="3" cx="12" cy="12"></circle>
                </svg>
              </div>
              <h3 className="firewall-configuration-review-service-title">
                Continuous Hardening Support
              </h3>
              <p className="firewall-configuration-review-service-description">
                Ongoing validation and refinement of firewall policies with
                quarterly reviews and real-time threat intelligence integration.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="process-vertical-section">
        <div className="process-container firewall-configuration-review-process-container">
          <div className="firewall-configuration-review-process-header process-header">
            <h2 className="section-title">
              Documentation &amp; Discovery Phase
            </h2>
            <p className="section-subtitle">
              Building a complete picture of your firewall infrastructure
            </p>
          </div>
          <div className="process-steps-vertical">
            <div className="process-step-vertical">
              <div className="process-step-marker">
                <span className="firewall-configuration-review-process-step-number">
                  01
                </span>
              </div>
              <div className="firewall-configuration-review-process-step-content">
                <h3 className="firewall-configuration-review-process-step-title">
                  Inventory Collection
                </h3>
                <p className="firewall-configuration-review-process-step-description">
                  Systematic extraction of all firewall configurations,
                  rulesets, object definitions, and network topology
                  documentation from all managed devices and security zones.
                </p>
              </div>
            </div>
            <div className="process-step-vertical">
              <div className="process-step-marker">
                <span className="firewall-configuration-review-process-step-number">
                  02
                </span>
              </div>
              <div className="firewall-configuration-review-process-step-content">
                <h3 className="firewall-configuration-review-process-step-title">
                  Policy Mapping
                </h3>
                <p className="firewall-configuration-review-process-step-description">
                  Comprehensive mapping of firewall rules to business
                  applications, network segments, and data flows to understand
                  the purpose and criticality of each policy.
                </p>
              </div>
            </div>
            <div className="process-step-vertical">
              <div className="process-step-marker">
                <span className="firewall-configuration-review-process-step-number">
                  03
                </span>
              </div>
              <div className="firewall-configuration-review-process-step-content">
                <h3 className="firewall-configuration-review-process-step-title">
                  Segmentation Analysis
                </h3>
                <p className="firewall-configuration-review-process-step-description">
                  Detailed evaluation of network segmentation boundaries, VLAN
                  configurations, DMZ isolation, and inter-zone trust
                  relationships to identify potential lateral movement paths.
                </p>
              </div>
            </div>
            <div className="process-step-vertical">
              <div className="process-step-marker">
                <span className="firewall-configuration-review-process-step-number">
                  04
                </span>
              </div>
              <div className="firewall-configuration-review-process-step-content">
                <h3 className="firewall-configuration-review-process-step-title">
                  Gap Identification
                </h3>
                <p className="firewall-configuration-review-process-step-description">
                  Identification of security policy gaps, missing controls,
                  exposed services, and compliance deviations through automated
                  scanning and manual expert analysis.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="process-horizontal-section">
        <div className="process-container firewall-configuration-review-process-container">
          <div className="firewall-configuration-review-process-header process-header">
            <h2 className="section-title">Our Proven Review Methodology</h2>
            <p className="section-subtitle">
              Structured approach to firewall security assessment and hardening
            </p>
          </div>
          <div className="process-steps-horizontal">
            <div className="process-step-horizontal">
              <div className="firewall-configuration-review-process-step-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m21 21l-4.34-4.34"></path>
                    <circle r="8" cx="11" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-step-info">
                <span className="process-step-label">Phase 1</span>
                <h3 className="process-step-name">Discovery</h3>
                <p className="process-step-text">
                  Comprehensive audit of current firewall infrastructure and
                  policies
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-process-step-connector"></div>
            <div className="process-step-horizontal">
              <div className="firewall-configuration-review-process-step-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="process-step-info">
                <span className="process-step-label">Phase 2</span>
                <h3 className="process-step-name">Risk Assessment</h3>
                <p className="process-step-text">
                  Identify critical vulnerabilities and prioritize based on
                  business impact
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-process-step-connector"></div>
            <div className="process-step-horizontal">
              <div className="firewall-configuration-review-process-step-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M9 12h6m-3-3v6m8-2c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="process-step-info">
                <span className="process-step-label">Phase 3</span>
                <h3 className="process-step-name">Remediation Planning</h3>
                <p className="process-step-text">
                  Develop actionable hardening roadmap with phased
                  implementation
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-process-step-connector"></div>
            <div className="process-step-horizontal">
              <div className="firewall-configuration-review-process-step-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="process-step-info">
                <span className="process-step-label">Phase 4</span>
                <h3 className="process-step-name">Validation</h3>
                <p className="process-step-text">
                  Verify effectiveness and ensure compliance with security
                  standards
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="firewall-configuration-review-deliverables-section">
        <div className="deliverables-container firewall-configuration-review-deliverables-container">
          <div className="firewall-configuration-review-deliverables-header deliverables-header">
            <h2 className="section-title">Comprehensive Review Deliverables</h2>
            <p className="section-subtitle">
              Actionable insights and strategic recommendations
            </p>
          </div>
          <div className="deliverables-grid firewall-configuration-review-deliverables-grid">
            <div className="firewall-configuration-review-deliverable-card">
              <div className="deliverable-image">
                <img
                  alt="Close-up view of a detailed architectural blueprint with intricate designs and data points."
                  src="https://images.pexels.com/photos/4458195/pexels-photo-4458195.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="deliverable-content">
                <div className="firewall-configuration-review-deliverable-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="firewall-configuration-review-deliverable-title">
                  Policy Hygiene Report
                </h3>
                <p className="firewall-configuration-review-deliverable-description">
                  Detailed analysis of rule redundancy, policy conflicts, unused
                  rules, and security weaknesses with risk severity ratings and
                  business impact assessment.
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-deliverable-card">
              <div className="deliverable-image">
                <img
                  alt="Engineer reviewing architectural blueprints on a desk with technical drawings."
                  src="https://images.pexels.com/photos/6615234/pexels-photo-6615234.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="deliverable-content">
                <div className="firewall-configuration-review-deliverable-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="firewall-configuration-review-deliverable-title">
                  Rule Optimization Plan
                </h3>
                <p className="firewall-configuration-review-deliverable-description">
                  Comprehensive strategy to consolidate, simplify, and optimize
                  firewall rules for enhanced performance, maintainability, and
                  security posture.
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-deliverable-card">
              <div className="deliverable-image">
                <img
                  alt="A modern server room featuring network equipment with blue illumination. Ideal for technology themes."
                  src="https://images.pexels.com/photos/17323801/pexels-photo-17323801.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="deliverable-content">
                <div className="firewall-configuration-review-deliverable-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="16" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="2" y="16" rx="1" width="6" height="6"></rect>
                      <rect x="9" y="2" rx="1" width="6" height="6"></rect>
                      <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3m-7-4V8"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="firewall-configuration-review-deliverable-title">
                  Segmentation Blueprint
                </h3>
                <p className="firewall-configuration-review-deliverable-description">
                  Network architecture design with recommended zone boundaries,
                  trust levels, traffic flow patterns, and zero-trust
                  segmentation principles.
                </p>
              </div>
            </div>
            <div className="firewall-configuration-review-deliverable-card">
              <div className="deliverable-image">
                <img
                  alt="A detailed circuit diagram on a chalkboard with sticky notes, ideal for educational and academic themes."
                  src="https://images.pexels.com/photos/8471851/pexels-photo-8471851.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                />
              </div>
              <div className="deliverable-content">
                <div className="firewall-configuration-review-deliverable-icon">
                  <svg
                    width="28"
                    xmlns="http://www.w3.org/2000/svg"
                    height="28"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M3 3v16a2 2 0 0 0 2 2h16m-3-4V9m-5 8V5M8 17v-3"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <h3 className="firewall-configuration-review-deliverable-title">
                  Remediation Timeline
                </h3>
                <p className="firewall-configuration-review-deliverable-description">
                  Phased implementation roadmap with prioritized tasks, resource
                  requirements, rollback procedures, and compliance milestone
                  tracking.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="firewall-configuration-review-compliance-section">
        <div className="firewall-configuration-review-compliance-container">
          <div className="firewall-configuration-review-compliance-header">
            <h2 className="section-title">
              Compliance &amp; Standards Alignment
            </h2>
            <p className="section-subtitle">
              Mapping firewall controls to regulatory frameworks
            </p>
          </div>
          <div className="compliance-table-wrapper">
            <table className="compliance-table">
              <thead>
                <tr>
                  <th>
                    <span>Standard</span>
                  </th>
                  <th>
                    <span>Control Domain</span>
                  </th>
                  <th>
                    <span>Firewall Requirements</span>
                  </th>
                  <th>
                    <span>Validation Method</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>ISO 27001</strong>
                  </td>
                  <td>
                    <span>A.13.1 Network Security Management</span>
                  </td>
                  <td>
                    <span>
                      Network segregation, access control policies, boundary
                      protection
                    </span>
                  </td>
                  <td>
                    <span>Rule audit, segmentation testing, policy review</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>SOC 2</strong>
                  </td>
                  <td>
                    <span>CC6.6 Logical Access Controls</span>
                  </td>
                  <td>
                    <span>
                      Least privilege enforcement, traffic filtering, logging
                      and monitoring
                    </span>
                  </td>
                  <td>
                    <span>
                      Configuration review, traffic analysis, log inspection
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>PCI-DSS</strong>
                  </td>
                  <td>
                    <span>Requirement 1: Firewall Configuration</span>
                  </td>
                  <td>
                    <span>
                      Cardholder data environment isolation, deny-by-default,
                      change control
                    </span>
                  </td>
                  <td>
                    <span>
                      Rule documentation, DMZ testing, change tracking
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>NIST CSF</strong>
                  </td>
                  <td>
                    <span>PR.AC-5: Network Integrity</span>
                  </td>
                  <td>
                    <span>
                      Network segmentation, boundary defense, traffic inspection
                    </span>
                  </td>
                  <td>
                    <span>Architecture review, traffic flow validation</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>CIS Controls</strong>
                  </td>
                  <td>
                    <span>Control 13: Network Monitoring</span>
                  </td>
                  <td>
                    <span>
                      Firewall rule management, port filtering, unauthorized
                      access prevention
                    </span>
                  </td>
                  <td>
                    <span>Rule effectiveness testing, port scanning</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>GDPR</strong>
                  </td>
                  <td>
                    <span>Article 32: Security of Processing</span>
                  </td>
                  <td>
                    <span>
                      Data flow controls, encryption enforcement, access
                      restrictions
                    </span>
                  </td>
                  <td>
                    <span>
                      Data mapping, encryption validation, access testing
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="firewall-configuration-review-thq-cta-section-elm cta-section firewall-configuration-review-cta-section">
        <div className="firewall-configuration-review-thq-cta-wrapper-elm cta-wrapper firewall-configuration-review-cta-wrapper">
          <div className="cta-content-block">
            <div className="cta-icon-feature">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h2 className="section-title">Secure Your Network Perimeter</h2>
            <p className="section-content">
              Don&apos;t let misconfigured firewall rules expose your
              organization to cyber threats. Our expert team will conduct a
              thorough review and provide actionable recommendations to harden
              your defenses.
            </p>
          </div>
          <div className="firewall-configuration-review-thq-cta-action-block-elm cta-action-block">
            <div className="firewall-configuration-review-cta-card">
              <h3 className="firewall-configuration-review-cta-card-title">
                Request Assessment
              </h3>
              <p className="firewall-configuration-review-cta-card-description">
                Get a comprehensive firewall configuration review with detailed
                findings and a strategic remediation roadmap.
              </p>
              <a href="#assessment">
                <div className="btn btn-lg btn-secondary">
                  <span>Request Assessment</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="firewall-configuration-review-container2">
        <div className="firewall-configuration-review-container3">
          <Script
            html={`<script defer data-name="hero-animations">
(function(){
  const heroSection = document.querySelector(".hero-section")
  const heroContent = document.querySelector(".hero-content")

  if (heroSection && heroContent) {
    const handleScroll = () => {
      const scrolled = window.pageYOffset
      const parallaxOffset = scrolled * 0.3

      if (heroContent) {
        heroContent.style.transform = \`translateY(\${parallaxOffset}px)\`
        heroContent.style.opacity = 1 - scrolled / 600
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
  }

  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = "1"
          entry.target.style.transform = "translateY(0)"
        }, index * 100)
        fadeInObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)

  const animatedElements = document.querySelectorAll(".service-card, .stat-card, .deliverable-card, .process-step-horizontal")
  animatedElements.forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(30px)"
    el.style.transition = "opacity 0.5s ease, transform 0.5s ease"
    fadeInObserver.observe(el)
  })

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const allAnimatedElements = document.querySelectorAll('[style*="transition"]')
    allAnimatedElements.forEach((el) => {
      el.style.transition = "none"
      el.style.opacity = "1"
      el.style.transform = "none"
    })
    window.removeEventListener("scroll", handleScroll)
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default FirewallConfigurationReview
